import TRANSLATION_ACCESSIBILITY_ID from './accessibility/translation';
import TRANSLATION_BOOKING_ID from './booking/translation';
import TRANSLATION_EVENTS_ID from './events/translation';
import TRANSLATION_EXPERIENCES_ID from './experiences/translation';
import TRANSLATION_FORM_ID from './form/translation';
import TRANSLATION_LANDING_PAGES_ID from './landingPages/translation';
import TRANSLATION_RESERVE_ID from './reserve/translation';
import TRANSLATION_SIGNIN_ID from './signin/translation';
import TRANSLATION_DATES_ID from './weekdays/translation';

export default {
  ...TRANSLATION_ACCESSIBILITY_ID,
  ...TRANSLATION_BOOKING_ID,
  ...TRANSLATION_DATES_ID,
  ...TRANSLATION_EVENTS_ID,
  ...TRANSLATION_EXPERIENCES_ID,
  ...TRANSLATION_FORM_ID,
  ...TRANSLATION_LANDING_PAGES_ID,
  ...TRANSLATION_RESERVE_ID,
  ...TRANSLATION_SIGNIN_ID,
};
